import React from "react";
import { TailSpin } from "react-loader-spinner";

const Loader = () => <TailSpin wrapperClass="spinner-header-sticky" color="#FFFFFF" height={18} width={18} />;

export default Loader;
